// extracted by mini-css-extract-plugin
module.exports = {"DialogActions":"CreateUpdateSeason_DialogActions__2mEl6"};